// Quem pode ser editada — regra única, em função pura pra dar pra testar.
//
// Contexto: o menu de contexto oferecia "Editar" em QUALQUER mensagem saída,
// sem checar se a edição tinha chance de funcionar. Em produção (A&T,
// medição de 2026-08-04) são 1.145 mensagens saintes sem `source_id` — 3,85%
// do total — e NENHUMA delas é recente: zero na última hora, 1.090 com mais
// de um dia.
//
// O advogado clicava em Editar, recebia "aguarde a confirmação de envio
// (poucos segundos)", esperava, tentava de novo — e nunca funcionava. Na
// frente do cliente.
//
// É a mesma classe do achado de 2026-07-15 no botão de reação ("aparecia e
// falhava silencioso"), que já tinha sido resolvida lá e nunca aplicada aqui.

// Limite da plataforma, não nosso: o WhatsApp recusa edição depois disso.
export const JANELA_EDICAO_WHATSAPP_MS = 15 * 60 * 1000;

/**
 * `createdAt` chega em segundos na maior parte do app, mas alguns caminhos já
 * mandam milissegundos. Mesma heurística do separador de data das mensagens.
 */
export const normalizarParaMs = createdAt => {
  const n = Number(createdAt);
  if (!Number.isFinite(n) || n <= 0) return null;
  return n > 1e12 ? n : n * 1000;
};

export const ehInboxWhatsApp = (inbox = {}) =>
  !!(inbox?.is_waha || inbox?.is_evolution);

/**
 * Decide se vale oferecer "Editar" para uma mensagem.
 *
 * @param {object} params
 * @param {object} params.inbox      Inbox da conversa
 * @param {string} params.sourceId   ID da mensagem na plataforma externa
 * @param {number} params.createdAt  Epoch (s ou ms)
 * @param {number} [params.agora]    Injetável pra teste
 * @returns {boolean}
 */
export const podeEditarMensagem = ({
  inbox = {},
  sourceId = '',
  createdAt,
  agora = Date.now(),
}) => {
  // Web e e-mail editam localmente: não dependem de plataforma externa nem
  // de janela de tempo.
  if (!ehInboxWhatsApp(inbox)) return true;

  // Envio nunca confirmado pelo webhook `send.message`: sem o ID real da
  // mensagem no WhatsApp, não existe o que editar do lado do cliente.
  if (!sourceId) return false;

  // Importadas do Digisac (`source_id` tipo "digisac_...") não têm ID nativo
  // da Evolution — mesmo motivo pelo qual a reação já as ignora.
  if (inbox?.is_evolution && !/^WAID:/.test(sourceId)) return false;

  const criadaEm = normalizarParaMs(createdAt);
  if (criadaEm === null) return false;

  return agora - criadaEm < JANELA_EDICAO_WHATSAPP_MS;
};
